// extracted by mini-css-extract-plugin
export default {"formControl":"Input_formControl__CsSVc","input":"Input_input__QxhK4","label":"Input_label__dLQSg","error":"Input_error__guDeK"};